import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { TireEventTimeline } from "./TireEventTimeline";

interface Tire {
  id: string;
  serial_number?: string;
  brand?: string;
  model?: string;
}

interface TireHistorySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tire: Tire | null;
}

export function TireHistorySheet({
  open,
  onOpenChange,
  tire,
}: TireHistorySheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:w-[550px] p-0">
        <SheetHeader className="px-6 pt-6 pb-4 border-b">
          <SheetTitle>
            Histórico do Pneu
          </SheetTitle>
          <SheetDescription>
            {tire ? (
              <>
                {tire.brand} {tire.model}
                {tire.serial_number && ` - ${tire.serial_number}`}
              </>
            ) : (
              "Nenhum pneu selecionado"
            )}
          </SheetDescription>
        </SheetHeader>

        <ScrollArea className="h-[calc(100vh-120px)] px-6 py-6">
          {tire && <TireEventTimeline tireId={tire.id} />}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
